export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";